(() => {
  'use strict';

  const STORAGE_KEY = 'atemp_wishlist_v1';
  const CHANGE_EVENT = 'atemp:wishlist:change';
  const LINK_SELECTOR = '[data-atemp-wishlist-header-link]';
  const COUNT_SELECTOR = '[data-atemp-wishlist-count]';

  const getCount = () => {
    if (window.ATEMPWishlist?.count) {
      return window.ATEMPWishlist.count();
    }

    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);

      if (!raw) return 0;

      const parsed = JSON.parse(raw);
      const items = Array.isArray(parsed)
        ? parsed
        : parsed?.items;

      return Array.isArray(items) ? items.length : 0;
    } catch (error) {
      console.warn(
        '[ATEMP Wishlist Header] Não foi possível ler os favoritos.',
        error
      );

      return 0;
    }
  };

  const update = () => {
    const count = getCount();
    const visibleCount = count > 99 ? '99+' : String(count);

    const label =
      count === 0
        ? 'Favoritos, nenhum produto salvo'
        : count === 1
          ? 'Favoritos, 1 produto salvo'
          : `Favoritos, ${count} produtos salvos`;

    document
      .querySelectorAll(COUNT_SELECTOR)
      .forEach((element) => {
        // Trava de segurança: impede que o script apague a raiz do site (<html> ou <body>)
        if (element === document.documentElement || element === document.body) {
          return;
        }

        element.textContent = visibleCount;
        element.hidden = count === 0;
      });

    document
      .querySelectorAll(LINK_SELECTOR)
      .forEach((link) => {
        link.classList.toggle('has-items', count > 0);
        link.setAttribute('aria-label', label);
        link.title = label;
      });
  };

  window.addEventListener(CHANGE_EVENT, update);

  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) {
      update();
    }
  });

  document.addEventListener('shopify:section:load', update);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      update,
      { once: true }
    );
  } else {
    update();
  }
})();